import { paymentTypesConstants } from '../_constants';
import * as commonAction from './commonAction';
import { paymentTypesService } from '../_services';
import { alertActions } from '.';

export const paymentTypesActions = {
    getPaymentTypesList,
    updateStatus
};

//-- getPaymentTypesList
function getPaymentTypesList(apiName, paymentTypesData) {

    return dispatch => {
        dispatch(commonAction.request(paymentTypesConstants.PAYMENT_TYPES_LIST_REQUEST, paymentTypesData));
        paymentTypesService.getPaymentTypesList(apiName, paymentTypesData)
            .then(
                paymentTypes => {

                    //console.log("Successfully",paymentTypes.data);
                    dispatch(commonAction.success(paymentTypesConstants.PAYMENT_TYPES_LIST_SUCCESS, paymentTypes.data));
                    if (paymentTypes.success == false) {
                        dispatch(commonAction.failure(paymentTypesConstants.PAYMENT_TYPES_LIST_ERROR, paymentTypes.message));
                        dispatch(alertActions.error(paymentTypes.message));
                    }
                },
                error => {
                    dispatch(alertActions.error(error.response.data.error));
                }
            );
    };
}

//-- updateStatus
function updateStatus(apiName, myData, paymentTypesData) {
    let getApi = paymentTypesData.api;
    let postData = {};
    postData.page = paymentTypesData.page;
    postData.orderBy = paymentTypesData.orderBy;
    postData.orderByAscDesc = paymentTypesData.orderByAscDesc;
    postData.role = paymentTypesData.roleType;
    postData.perPage = paymentTypesData.perPage;
    return dispatch => {
        dispatch(
            commonAction.request(
                paymentTypesConstants.PAYMENT_TYPES_LIST_REQUEST,
                myData
            )
        );
        paymentTypesService.updatePaymentType(apiName, myData).then(
            user => {
                dispatch(alertActions.success("Status updated successfully"));
                setTimeout(function () {
                    dispatch(alertActions.clear())
                }, 3000);

                dispatch(getPaymentTypesList(getApi, postData))
            },
            error => {
                dispatch(alertActions.error(error.response.data.error));
            }
        );
    };
}
